import React from 'react';
import './ContactInfoRendering.css';

const ContactInfoRendering = ({firstName, lastName, email, phone, address}) => {
  // Function to create a vCard content
  console.log(address['value'] !='' || address['value'] != null)
  const generateVCard = () => {
    const vCardData = `
BEGIN:VCARD
VERSION:3.0
${(firstName?.value || lastName?.value) ? `N:${lastName?.value || ''};${firstName?.value || ''};;;` : ''}
${email?.value ? `EMAIL:${email.value}` : ''}
${phone?.value ? `TEL:${phone.value}` : ''}
${address?.value ? `ADR:;;${address.value};;;;` : ''}
END:VCARD`;
;
    const blob = new Blob([vCardData], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);

    // Create a temporary download link
    const link = document.createElement('a');
    link.href = url;
    link.download = `${firstName['value'] || 'contact'}_${lastName['value'] || 'info'}.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="container">
      <div>
        <div className="contact-info">
          {firstName['value'] && <p><strong>First Name:</strong> {firstName['value']}</p>}
          {lastName['value'] && <p><strong>Last Name:</strong> {lastName['value']}</p>}
          {email['value'] && <p><strong>Email:</strong> {email['value']}</p>}
          {phone['value'] && <p><strong>Phone:</strong> {phone['value']}</p>}
          {address['value'] && <p><strong>Address:</strong> {address['value']}</p>}
        </div>
        {(firstName['value'] || lastName['value'] || email['value'] || phone['value'] || address['value']) && (
          <button className="download-btn" onClick={generateVCard}>
            Download vCard
          </button>
        )}
      </div>
    </div>
  );
};

export default ContactInfoRendering;
